export default __webpack_public_path__ + "static/osstmm-blue-429b20f4020f100dbcd07397805393e5.png";